import { render } from "./hardware-info.vue?vue&type=template&id=22451790&scoped=true&ts=true"
import script from "./hardware-info.vue?vue&type=script&lang=ts"
export * from "./hardware-info.vue?vue&type=script&lang=ts"

import "./hardware-info.vue?vue&type=style&index=0&id=22451790&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22451790"]])

export default __exports__